export default (props: any) => {
  return (
    <img
      className="pt-3 mb-4 m-auto max-h-[50vh]"
      src="/images/professional_finished.png"
      alt="professional_finished"
    />
  );
};
